<template>       
    <div class="row  ">
        <div class="col-sm-12 ">
            <v-calendar is-expanded  :masks="masks" :attributes="attributes" :first-day-of-week="first_day_of_week" ref="trzcalendar"
                class='v-calendar '   @update:to-page="monthDetails" :from-page="page">
                <template slot="day-content" class='vc-w-full vc-relative' slot-scope='{day}'>
                    <div v-bind:class='{"holiday": weekly_holidays.includes(day.weekday)}'>
                        <div v-if="this_month_holidays[day.id]" :style="{'background-color':this_month_holidays[day.id].color}" :title="this_month_holidays[day.id].title">                                
                            <div class="flex flex-column h-100 overflow-hidden">
                                
                                <div class="day-label text-sm text-gray-900 cursor-pointer" v-if="this_month_holidays[day.id].can_edit == 1 && this_month_holidays[day.id].status!='absent'" @click="loadAttendance(day, this_month_holidays[day.id])">{{day.day}}</div>
                                <div class="day-label text-sm text-gray-900 " v-else>{{day.day}}</div>
                                
                            </div>
                        </div>
                        <div v-else>                                
                            <div class="flex flex-column h-100 overflow-hidden">
                                <div class="day-label text-sm text-gray-900" >{{day.day}}</div>
                            </div>
                        </div>
                    </div>
                    
                </template>
            </v-calendar>

            <div class="legend mt-4 row trz_borders px-3">                                                
                
                    <div class="col-sm-2 " style="background:#38c172">Present</div>
                    <div class="col-sm-2 bg-danger">Absent</div>
                    <div class="col-sm-2  " v-bind:style="'background:'+weekend_color_code">Weekend</div>                                                    
                    <div class="col-sm-2 " v-bind:style="'background:'+holiday_color_code">Holiday</div>
                    <div class="col-sm-2 " style="background:#FFD300">Late</div>
                    
                    <div class="col-sm-2 " v-for="leavetype  in leavetypes" :key="leavetype.id" v-bind:style="'background:'+leavetype.color_code">
                        {{leavetype.title}}
                    </div>

                
            </div>
        </div>
        <b-modal id="bv-modal-show-attendance-activity-log" size="lg" hide-footer title="ActivityLog">
           <activity-log-front :key="activateKey"  :attendance_date ="this.attendance_date"  > </activity-log-front>
        </b-modal>
    </div>
</template>
<script>
    import moment from 'moment'
    export default{
        mounted() {
            this.$refs.trzcalendar;
        },
        props: [ 'flg'],
        components: {},
        data(){ 
            const now = new Date();    
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());     
            const maxDate = new Date(today);
            maxDate.setMonth(maxDate.getMonth());

            const minDate = new Date(today)
            minDate.setMonth(minDate.getMonth()); 
            minDate.setDate(1);

            return {
                leave_available : [],
                leavetypes: [],

                weekend_color_code : '#aaaaaa',
                holiday_color_code : '#aaaaaa',
               
                count_leaves : 0,
                public_info : [],
                avatarsrc : '',
                avatarsrc1 : '',                
                company_avatarsrc1 : '',      
                img_src : this.$api_url+'/images/employee_dasboard/', 
                cr : 0, 

                

                this_month : 1,
                this_year : 2020,
                
                weekly_holidays : [6],
                first_day_of_week : 7,
                this_month_holidays : [],
                week_holidays : [6],
                all_week_holidays : [6],
                holidays_date_arr : [],

                header_year_month : '',

                start_date: null,
                end_date: null,

                attendances_date : null,

                check_in : null, 
                checkout : null,
                work_time : 0,
                break_time : 0,
                over_time : 0,
                activity_log : null,

                fdata: {check_in: null, checkout:null , absent:0 , attendances_date:''},

                total_working_day : 0,
                total_weekends : 0,
                total_holidays : 0,
                total_absent : 0,
                total_leaves : 0,
                masks : 
                    {
                        title: 'MMMM YYYY',
                        weekdays: 'WW',
                        navMonths: 'MMM',
                        input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                        dayPopover: 'WWW, MMM D, YYYY',
                        data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                    },

                attributes: [
                        {
                            key: 'today',
                            dot: 'pink',
                            dates: new Date(),
                        }
                    ],
               page: { month: '', year: '' },
            }
            
        },
        methods:{ 
            resetdata : function()
            {
                this.attendances_date = null;
                this.check_in = null;
                this.checkout = null;
                this.work_time = 0;
                this.break_time = 0;
                this.over_time = 0;
                this.activity_log = null;

                this.fdata = {};
            },
            loadAttendance :function(day)
            {
                this.attendance_date = day.id;
                this.resetdata();                    
                this.$bvModal.show('bv-modal-show-attendance-activity-log');
                
            },  
            monthDetails: function(x='' , y=0, m=0)
            {                
                let currentObj = this;
                let year = 0;
                let month = 0;
                
                if(y == 0)    
                {
                    year = x['year'];
                    month = x['month'];
                }   
                else
                {
                    year = y;
                    month = m;
                }  
                
                //alert(year + ' ' + month);
                    
                let st_date = new Date(year , month - 1 , 1);
                let en_date = new Date(year , month , 0);   

                
                this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
                this.end_date = moment(String(en_date)).format('Do MMMM YYYY');
                
                // fetch holidays dynamically from controller
                axios.get(this.$api_url+'/front/employee/attendances/details' , {
                    params: {
                        st_date: this.start_date,
                        en_date: this.end_date,
                    }
                }).then(function(response){

                    this.all_week_holidays = response.data.report.week_holidays.split(',').map(function(item){ return parseInt(item, 10);});
                    this.holidays_date_arr = response.data.report.holidays_date_arr.split(',').map(function(item){ return item;});
                    this.weekly_holidays = response.data.report.week_holidays.split(',').map(function(item){ return parseInt(item, 10) + 1;});
                    this.first_day_of_week = parseInt(response.data.report.week_start_day) + 1;
                    
                    this.this_month_holidays = response.data.holidays;

                    this.total_working_day = response.data.report.total_working_day;
                    this.total_weekends = response.data.report.weekends;
                    this.total_holidays = response.data.report.holidays;
                    this.total_absent = response.data.report.absent;
                    this.total_leaves = response.data.report.total_leaves;

                    this.weekend_color_code = response.data.report.weekend_color_code;
                    this.holiday_color_code = response.data.report.holiday_color_code;

                    //this.$refs.trzcalendar;
                    
                        
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});;

            }, 
            getLeaveTypes: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                axios.get(this.$api_url+'/front/leave/types?f=1' , {
                    params: {
                        
                    }
                }).then(function(response){
                    
                    this.leavetypes = response.data;
                    
                }.bind(this));
            }, 
         },
        created: function(){
            // this.getLeaves();
            this.getLeaveTypes();
        },
        computed: 
        {
            fetchStartWeekday()
            {
                return parseInt(this.first_day_of_week) - 1;
            },
        }
    }
</script>